module.exports = __webpack_public_path__ + "components/rewards/skiset/static/logo-54b9c50bfd05945c17fe476ebe628586.jpg";